import { RefreshCw } from 'lucide-react'
import { toast } from 'sonner'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { useTriggerHaloUserSync } from '@/features/halocrm-user/hooks'

export function HaloUserSyncCard() {
  const sync = useTriggerHaloUserSync()

  const handleClick = async () => {
    try {
      const result = await sync.mutateAsync()
      toast.success(
        `Synchronizacja OK: zaktualizowano ${result.upserted}, oznaczono nieaktywnych ${result.markedInactive}`,
      )
    } catch (err) {
      const status = (err as { response?: { status?: number } })?.response?.status
      if (status === 503) {
        toast.error('halocrm niedostępny - sprawdź INTERNAL_API_KEY i połączenie z halocrm')
      } else if (status === 403) {
        toast.error('Brak uprawnień (wymagany superuser)')
      } else {
        const msg = err instanceof Error ? err.message : 'Nieznany błąd'
        toast.error(`Synchronizacja nie powiodła się: ${msg}`)
      }
    }
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Synchronizacja użytkowników halocrm</CardTitle>
        <CardDescription>
          Pobiera listę użytkowników halocrm do lokalnej kopii w easycrm. Cron leci automatycznie
          co 6h - przycisk wymusza odświeżenie teraz.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Button onClick={handleClick} disabled={sync.isPending} className="gap-2">
          <RefreshCw className={sync.isPending ? 'size-4 animate-spin' : 'size-4'} />
          {sync.isPending ? 'Synchronizuję...' : 'Uruchom synchronizację'}
        </Button>
      </CardContent>
    </Card>
  )
}
